// deployEnv may replaced by build script
// replace result: in build process, no process.env.DEPLOY_ENV found, use prod instead
export const DEPLOY_ENV = 'prod';
